var imagesLoaded = require("imagesloaded");
import Bound from "bounds.js";

export default class Smooth {
  constructor() {
    this.isMobile = App.env.isMobile;

    this.config = {
      // height: window.innerHeight,
      // width: window.innerWidth,
      width: App.bounds.window_w,
      height: App.bounds.window_h,
    };

    this.dom = {
      el: document.querySelector("[data-scroll]"),
      content: document.querySelector("[data-scroll-content]"),
    };

    this.data = {
      ease: 0.1,
      current: 0,
      last: 0,
    };
    this.cache = [];

    this.rAF = null;

    // Init Bound (Intersection Observer)
    this.boundary = Bound({
      threashold: 0.0,
      margins: {
        top: 0,
        bottom: 0,
        // top: App.bounds.window_h / -10,
        // bottom: App.bounds.window_h / -10,
      },
    });

    RM.BM(this, ["run", "onAppInit", "onAppLoaded", "onAppLoadedEnded"]);
    this.setStyles();
  }

  init() {
    const t = this;
    this.config = {
      // height: window.innerHeight,
      // width: window.innerWidth,
      width: App.bounds.window_w,
      height: App.bounds.window_h,
    };

    this.data = {
      ease: 0.1,
      current: 0,
      last: 0,
    };

    this.cache = [];

    this.rAF = null;

    this.dom.content = document.querySelector("[data-scroll-content]");
    this.dom.springElems = Array.from(
      this.dom.content.querySelectorAll(".js-spring-element")
    );

    this.preload();
    this.setCache();
    this.setHeight();

    this.on();

    // Listen to event to recalculate height again
    if (window.BaO_Load_More) {
      window.BaO_Load_More.onAjaxComplete = function (button, url) {
        console.log("BaO_Load_More event fired");

        t.setHeight();
      };
    }

    // Elements that needs to recalculate height on click
    var elemsResetHeight = Array.from(
      this.dom.content.querySelectorAll(
        ".wp-block-coblocks-accordion-item details"
      )
    );

    elemsResetHeight.forEach((elem, i) => {
      elem.addEventListener("click", (e) => {
        setTimeout(() => {
          t.setHeight();
          console.log("click", elem);
        }, 500);
      });
    });
  }

  preload() {
    imagesLoaded(this.dom.content, (instance) => {
      this.setHeight();
    });
  }

  setHeight() {
    if (this.isMobile) return;
    console.log("SmoothScroll setHeight");
    App.el.body.style.height = `${this.dom.content.offsetHeight}px`;
  }

  setStyles() {
    if (this.isMobile) return;
    this.dom.el.style.position = "fixed";
    this.dom.el.style.top = Util.hasClass(App.el.app, "admin-bar")
      ? App.bounds.window_w > 782
        ? 32
        : 46
      : 0;
    this.dom.el.style.left = 0;
    this.dom.el.style.height = "100%";
    this.dom.el.style.width = "100%";
    this.dom.el.style.overflow = "hidden";
  }

  setCache() {
    this.dom.springElems.forEach((elem, i) => {
      const elemCache = {};

      elemCache.el = elem;
      // elemCache.sy           = 0;
      // elemCache.dy           = elemCache.sy;
      elemCache.dy = 0;
      elemCache.isInViewport = false;
      elemCache.ease = elem.dataset.ease;
      elemCache.skew = Util.hasClass(elem, "js-skew-element");

      // Watch when html element intersect with window
      this.boundary.watch(
        elem,
        (ratio) => {
          // console.log('enter', this, ratio);
          elemCache.isInViewport = true;
        },
        (ratio) => {
          // console.log('leave', this);
          elemCache.isInViewport = false;
        }
      );

      this.cache.push(elemCache);
    });
  }

  on(requestAnimationFrame = true) {
    this.addEvents();

    requestAnimationFrame && this.requestAnimationFrame();
  }

  off(cancelAnimationFrame = true) {
    cancelAnimationFrame && this.cancelAnimationFrame();

    this.removeEvents();
  }

  run() {
    // this.data.current = App.scroll.current;
    // this.data.last = RM.Lerp(this.data.last, this.data.current, this.data.ease);
    // this.data.last = Math.floor(this.data.last * 100) / 100;
    // if (this.data.last < .1) {
    //   this.data.last = 0;
    // }

    // Transform scroll-content
    // const diff = this.data.current - this.data.last;
    // const acc = diff / this.config.width;
    // const velo =+ acc;
    // const skew = velo * 7.5;
    const skew = App.scroll.velo * 7.5;
    // const spring = velo * (diff * 2.5);
    const spring = App.scroll.velo * (App.scroll.diff * 2.5);

    // this.dom.content.style.transform = `translate3d(0, -${this.data.last}px, 0) skewY(${skew}deg)`;
    if (!this.isMobile) {
      // RM.T(this.dom.content, 0, -this.data.last, 'px');
      RM.T(this.dom.content, 0, -App.scroll.last, "px");
    }

    // Transform Spring Elems
    this.cache.forEach((elem, i) => {
      // const ease = `0.1${i}`;
      const ease = 0.2 + i / 100;
      // elem.dy = RM.Lerp(elem.dy, elem.sy, ease);
      elem.dy = RM.Lerp(elem.dy, spring, ease);
      elem.dy = Math.floor(elem.dy * 100) / 100;

      if (elem.isInViewport) {
        if (elem.skew) {
          elem.el.style.transform = `translate3d(0, -${elem.dy}px, 0) skewY(${skew}deg)`;
        } else {
          RM.T(elem.el, 0, -elem.dy, "px");
        }
      }
    });

    this.requestAnimationFrame();
  }

  requestAnimationFrame() {
    this.rAF = requestAnimationFrame(this.run);
  }

  cancelAnimationFrame() {
    cancelAnimationFrame(this.rAF);
  }

  // destroy() {
  //   App.el.body.style.height = ''

  //   this.data = null

  //   this.removeEvents()
  //   this.cancelAnimationFrame()
  // }

  addEvents() {}

  removeEvents() {}

  onAppInit() {
    this.init();
  }

  onAppLoaded() {}

  onAppLoadedEnded() {
    // setTimeout(() => this.setHeight(), 50);
    setTimeout(() => this.setHeight(), 250);
  }

  onAppScroll() {
    // const scrollY = window.scrollY || window.pageYOffset
    // this.data.current = scrollY
    // this.cache.forEach((elem) => {
    //   // el.sy = scrollY
    //   elem.isInViewport = Util.isInViewport(elem.el, 0.2)
    // })
  }

  onAppResize() {
    this.config = {
      // height: window.innerHeight,
      // width: window.innerWidth,
      width: App.bounds.window_w,
      height: App.bounds.window_h,
    };

    this.setHeight();
    // this.scroll();
  }
}
